import React from "react";
import { Box, HStack, Spinner, Text } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";

const shimmer = keyframes`0%{background-position:-200% 0}100%{background-position:200% 0}`;
const barSx = {
  background: "linear-gradient(90deg, var(--border, #e5e7eb) 25%, var(--bg, #f5f5f5) 50%, var(--border, #e5e7eb) 75%)",
  backgroundSize: "200% 100%",
  animation: `${shimmer} 1.5s ease-in-out infinite`,
};

/**
 * Loading placeholder with spinner + shimmer bars.
 * Usage: <LoadingBlock rows={8} hint="Loading reservations..." />
 */
export default function LoadingBlock({ rows = 6, hint = "Loading..." }) {
  return (
    <Box border="1px solid" borderColor="var(--border, #e5e7eb)" borderRadius="var(--radius-sm, 8px)" p="12px" bg="var(--bg, #fff)">
      <HStack spacing={2} mb={3}>
        <Spinner size="sm" />
        <Text fontSize="sm" color="var(--muted, #6b7280)">{hint}</Text>
      </HStack>

      {Array.from({ length: rows }).map((_, i) => (
        <Box
          key={i}
          height="12px"
          borderRadius="6px"
          mb="10px"
          sx={{ ...barSx, width: `${80 + ((i * 7) % 20)}%` }}
        />
      ))}
    </Box>
  );
}
